export default "__VITE_ASSET__zvAEcMOg__"